import { useEffect } from "react";

export function useDocumentTitle(title: string | null) {
  useEffect(() => {
    if (!title) return;
    document.title = title === "StanceKit" ? title : `${title} | StanceKit`;
  }, [title]);
}

export function titleForPath(pathname: string): string | null {
  if (/^\/guides\/[^/]+\/[^/]+\/items\/[^/]+$/.test(pathname)) return null;
  if (/^\/guides\/[^/]+\/[^/]+$/.test(pathname)) return null;
  if (/^\/decisions\/[^/]+$/.test(pathname)) return "Opening guide";

  return (
    {
      "/": "StanceKit",
      "/features": "Features",
      "/pricing": "Pricing",
      "/blog": "Product notes",
      "/library": "Published agenda",
      "/guides/new": "Create a guide",
      "/decisions/new": "Create a guide",
      "/account": "Account settings",
      "/import": "Import an agenda",
      "/about": "About",
      "/terms": "Terms of service",
      "/privacy": "Privacy policy",
      "/cookies": "Cookie notice",
      "/subscription/confirm": "Confirm subscription",
      "/unsubscribe": "Unsubscribe",
      "/reactivate": "Reactivate account",
    }[pathname] ?? "Page not found"
  );
}
